import api from '../auth/apiClient';
import { WaterLevelData, WaterLevelFilterState, WaterLevelFilterOptions } from '../types/waterLevel';

export class WaterLevelApiService {
    static async getWaterLevelDashboard(filters: WaterLevelFilterState = {}): Promise<WaterLevelData[]> {
        try {
            const params = Object.entries(filters).reduce((acc, [key, value]) => {
                if (
                    value !== undefined &&
                    value !== null &&
                    (typeof value !== "string" || value.trim() !== "")
                ) {
                    acc[key] = value;
                }
                return acc;
            }, {} as Record<string, string | number>);

            console.log("Fetching water level dashboard with params:", params);

            const response = await api.get('/water-level/dashboard', { params });

            if (response.status !== 200) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            // Handle both array and object responses
            if (Array.isArray(response.data)) {
                return response.data;
            } else {
                // Convert object to array if needed
                return Object.values(response.data).filter(item =>
                    item && typeof item === 'object' && 'id' in item
                ) as WaterLevelData[];
            }
        } catch (error) {
            console.error("Error fetching water level dashboard:", error);
            throw error;
        }
    }

    static async getFilterOptions(): Promise<WaterLevelFilterOptions> {
        try {
            const response = await api.get('/water-level/filter-options');

            if (response.status !== 200) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            return response.data;
        } catch (error) {
            console.error("Error fetching filter options:", error);
            throw error;
        }
    }
}
